import { useMutation } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { renderChildren, Children } from '@sixfold/typed-render-props';
import React from 'react';

import {
  DeleteVehicleMutation as DeleteVehicleMutationResult,
  DeleteVehiclesMutation as DeleteVehiclesMutationResult,
  DeleteVehicleMutationVariables,
  DeleteVehiclesMutationVariables,
  PAGINATION_PAGE_SIZE,
} from '../../lib/graphql';
import { vehicleQuery, vehiclesQuery, deleteVehicleMutation, deleteVehiclesMutation } from '../graphql';

interface Props {
  children: Children<{
    deleteVehicle: (vehicleId: string, companyId: string) => Promise<void>;
    deleteVehicles: (vehicleIds: string[], companyId: string) => Promise<void>;
  }>;
}

export const VehicleMutation: React.FC<Props> = (props) => {
  const notify = useNotifications();
  const [deleteVehicle] = useMutation<DeleteVehicleMutationResult, DeleteVehicleMutationVariables>(
    deleteVehicleMutation,
  );
  const [deleteVehicles] = useMutation<DeleteVehiclesMutationResult, DeleteVehiclesMutationVariables>(
    deleteVehiclesMutation,
  );

  return renderChildren(props.children as React.ReactNode, {
    deleteVehicle: async (vehicleId: string, companyId: string) => {
      const response = await deleteVehicle({
        variables: {
          input: {
            vehicle_id: vehicleId,
          },
        },
        refetchQueries: [
          {
            query: vehicleQuery,
            variables: {
              vehicle_id: vehicleId,
            },
          },
          {
            query: vehiclesQuery,
            variables: {
              limit: PAGINATION_PAGE_SIZE,
              companyId,
            },
          },
        ],
      });

      notify.success({ title: 'Vehicle deleted' });
      return response;
    },
    deleteVehicles: async (vehicleIds: string[], companyId: string) => {
      const response = await deleteVehicles({
        variables: {
          input: {
            companyId,
            vehicleIds,
          },
        },
        refetchQueries: [
          {
            query: vehiclesQuery,
            variables: {
              limit: PAGINATION_PAGE_SIZE,
              companyId,
            },
          },
        ],
      });

      notify.success({ title: 'Vehicles deleted' });
      return response;
    },
  });
};
